// Importar dependencias
import ApiClient from "./ApiClient";

const businessesUrl = "businesses/";

// Función para obtener todos los clientes de un negocio
async function getBusiness() {
  // Realizamos la petición
  try {
    const result = await ApiClient.get(businessesUrl + "1");
    // Regresar datos de la petición
    return result.data;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

async function updateThankYouNote(thankYouNote) {
  // Realizamos la petición
  try {
    const result = await ApiClient.post(businessesUrl + "thank-you-note", {
      note: thankYouNote
    });
    // Regresar datos de la petición
    return result.data;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

async function getPrinterLicense() {
  // Realizamos la petición
  try {
    const result = await ApiClient.post(businessesUrl + "printer-license");
    // Regresar datos de la petición
    return result.data;
  } catch (err) {
    // en caso de un error, lanzamos el error
    throw new Error(err.response.data.message);
  }
}

export default {
  getBusiness,
  updateThankYouNote,
  getPrinterLicense
};
